// @flow
import createAction from 'Store/utils/createAction';

const CLOSE_TOAST = 'CLOSE_TOAST';

function closeToast() {
  return createAction(CLOSE_TOAST);
}

export { CLOSE_TOAST, closeToast };
